import React, { useState, useEffect } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { ArrowRightOutlined } from '@ant-design/icons'
import { backendGetRequest } from '../../../../helpers/callBackend'
import EntityPaymentsApplicationModal from './EntityPaymentsApplicationModal'
import PermissionGate from '../../../../helpers/PermissionGate'

const EntityPaymentsApplicationState = ({ entityId, isVerified, initialCustomerId }) => {
  const [text, setText] = useState('No')
  const [linkText, setLinkText] = useState('Start Application')
  const [customerObject, setCustomerObject] = useState({})
  const [appVisible, setAppVisible] = useState(false)
  const [customerId, setCustomerId] = useState(initialCustomerId ? initialCustomerId : '')
  const [customerObjectVerified, setCustomerObjectVerified] = useState(isVerified)

  const handleClick = () => {
    setAppVisible(true)
  }

  const getCustomerObject = async () => {
    const customerResp = await backendGetRequest('/api/arpari-dwolla/customer/', {
      params: {
        entity_id: entityId,
      },
    })
    if (customerResp.status !== 200) {
      return
    }
    setCustomerObject(customerResp.data?.data)
    if (customerResp.data?.data?.status === 'verified') {
      setAppVisible(false)
    }
  }

  useEffect(() => {
    if (!customerObjectVerified) {
      getCustomerObject()
    }
  }, [entityId, customerObjectVerified, customerId])

  useEffect(() => {
    if (initialCustomerId) {
      setCustomerId(initialCustomerId)
    }
    if (isVerified) {
      setCustomerObjectVerified(isVerified)
    }
  }, [isVerified, initialCustomerId])

  useEffect(() => {
    if (
      customerObjectVerified ||
      (customerObject?.status === 'verified' && !customerObject?._links?.hasOwnProperty('certify-beneficial-ownership'))
    ) {
      setText('Yes')
      setLinkText('')
    } else if (customerId && !customerObjectVerified) {
      setText('In Progress')
      setLinkText('View Application')
    } else {
      setText('No')
      setLinkText('Start Application')
    }
  }, [customerObject, isVerified, customerId])

  return (
    <Stack direction='row' spacing={0.5}>
      <Typography variant='primary'>{text}</Typography>
      {linkText && (
        <PermissionGate
          requiredRole='dashboardEditor'
          toolTipText='Only admins and dashboard editors may access the entity payments verification process'
          readOnly={
            <Link component='button' disabled sx={{ color: 'grey' }} underline='none'>
              {linkText}
              <ArrowRightOutlined style={{ marginLeft: '3px' }} />
            </Link>
          }
        >
          <Link
            underline='none'
            onClick={() => {
              handleClick()
            }}
          >
            {linkText}
            <ArrowRightOutlined style={{ marginLeft: '3px' }} />
          </Link>
        </PermissionGate>
      )}
      {appVisible && (
        <EntityPaymentsApplicationModal
          visible={appVisible}
          handleCancelModal={() => setAppVisible(false)}
          entityId={entityId}
          setCustomerId={setCustomerId}
          customer={customerObject}
          setCustomer={setCustomerObject}
          setCustomerObjectVerified={setCustomerObjectVerified}
        />
      )}
    </Stack>
  )
}

export default EntityPaymentsApplicationState
